'use strict';

import decorators from 'Decorators/index';
import { getFieldValidationMessage } from 'Components/form/form';
import { createValidationMessageElement, removeValidationMessageElement, toggleValidityClass } from 'app_vodafone_ziggo/util/validation';

import VZSelect from './VZSelect';

export class VZIdentification extends HTMLSelectElement {
    constructor() {
        super();

        decorators.readonly(this, this);
        decorators.idType(this);

        this.unselectable = '10';
        this.onModalClose = this.onModalClose.bind(this);
        this.updateDocumentNumberField = this.updateDocumentNumberField.bind(this);
        this.documentNationalityField = this.closest('form').querySelector('[name="dwfrm_checkoutDetails_identification_nationality"]');

        if (window.bs && window.bs.Modal) {
            const idTypeModalElement = document.getElementById('id-type-modal');

            if (idTypeModalElement) {
                this.idTypeModal = new window.bs.Modal(idTypeModalElement, { backdrop: 'static', keyboard: false });
            }
        }

        this.updateDocumentNumberField();
        this.updateDocumentTypeOptions = this.updateDocumentTypeOptions.bind(this);
    }

    connectedCallback() {
        this.vzSelect = new VZSelect();
        this.addEventListener('change', this.onChange);
        this.documentNationalityField.addEventListener('change', this.updateDocumentTypeOptions);
        this.documentNationalityField.addEventListener('blur', this.updateDocumentTypeOptions);

        // We need to trigger the change handler on blur as well
        this.addEventListener('blur', this.onChange);
        this.modalButtons = [...document.querySelectorAll('.js-id-modal-close')];
        this.modalButtons.forEach((button) => button.addEventListener('click', this.onModalClose));
        this.vzSelect.selectCorrectValue.bind(this)();
    }

    disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('blur', this.onChange);
        this.documentNationalityField.removeEventListener('change', this.updateDocumentTypeOptions);
        this.documentNationalityField.removeEventListener('blur', this.updateDocumentTypeOptions);

        this.modalButtons.forEach((button) => button.removeEventListener('click', this.onModalClose));
    }

    onModalClose() {
        this.selectedIndex = 0;
        const errorMessage = this.parentElement.querySelector('.error-msg');
        if (errorMessage) errorMessage.remove();
        this.classList.remove('invalid');
    }

    updateDocumentNumberField() {
        const documentNumberField = this.closest('form').querySelector('[name="dwfrm_checkoutDetails_identification_documentNumber"]');
        if (documentNumberField) {
            const selectedOptionLabel = this.options[this.selectedIndex].text.toLowerCase().split(' ').join('-');
            documentNumberField.dataset.selectedId = selectedOptionLabel;
        }
    }

    updateDocumentTypeOptions() {
        [...this.options].forEach((option) => {
            // id type 1 and 2 are not allowed for non-NL nationalities
            if (option.value === '1' || option.value === '2') {
                if (this.documentNationalityField.value !== 'NL') {
                    option.selected = false;
                    option.hidden = true;
                    option.disabled = true;
                } else {
                    option.hidden = false;
                    option.disabled = false;
                }
            }
        }, this);
    }

    onChange(evt) {
        if (!this.value) {
            createValidationMessageElement(getFieldValidationMessage(evt.target), evt.target);
            toggleValidityClass(false, evt.target);
        } else if (this.value === this.unselectable) {
            createValidationMessageElement(this.getAttribute('data-unavailable-msg'), evt.target);
            toggleValidityClass(false, evt.target);
            this.idTypeModal.show();
        } else {
            removeValidationMessageElement(evt.target);
            toggleValidityClass(true, evt.target);
        }

        this.updateDocumentNumberField();
    }
}

if (!window.customElements.get('vz-identification')) {
    window.customElements.define('vz-identification', VZIdentification, { extends: 'select' });
}
